export const TENDBE_APP_URL = "https://app.tendbe.com/";
export const TENDBE_BUSINESS_EMAIL = "business@tendbe.com";

export const getLandingMenuLinks = (t) => [
  { title: t("landing.nav.howItWorks"), link: "#how-it-works" },
  { title: t("landing.nav.customers"), link: "#customers" },
  { title: t("landing.nav.pricing"), link: "#pricing" },
];

export const getFooterLinks = (t) => [
  { title: t("landing.footer.contact"), href: `mailto:${TENDBE_BUSINESS_EMAIL}` },
  { title: t("landing.footer.pricing"), link: "#pricing" },
  { title: t("landing.footer.privacy"), to: "/privacy" },
  { title: t("landing.footer.terms"), to: "/terms" },
];
